import { SxProps, Theme } from "@mui/material";

export const headerStyles: SxProps<Theme> = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    my: 4,
    py: 1,
    zIndex: 999999,
};

export const logoLinkStyles: SxProps<Theme> = {
    textDecoration: "none",
    cursor: "pointer",
};

export const logoStyles: SxProps<Theme> = {
    width: "200px",
};
